export default __webpack_public_path__ + "static/media/rescue-lc-ico.f6e747f5.svg";